import { useEffect } from 'react';
import { ajaxExceptionMessage } from '@skunexus/utils';
import { useWarehouses } from './useWarehouses';

export function useWarehousesDictionary({ query, errorNotification }) {
    const [{ isFetching, error, dictionary }, { fetch }] = useWarehouses({
        query,
    });

    useEffect(() => {
        fetch();
    }, []);

    useEffect(() => {
        if (error) {
            errorNotification(ajaxExceptionMessage(error));
        }
    }, [error]);

    return [{ isFetching, dictionary }, {}];
}
